import React, { useReducer, createContext, useContext } from "react";
export const GlobalContext = createContext();

const initialState = {
  loading: false,
  dadosusuario: [],
  permissoesusuario: [],
  perfilselecionado: [],
  rolagem: [],
  empresaselecionada: [],
  enderecoselecionado: [],
  socioselecionado: [],
  sociodadosselecionado: [],
  novoselecionado: {},
  notificacao: "",
  tema: "dark",
  backpage: false,
  menulateral: [],
  situacaofiscal: "",
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_RESET":
      let resetState = JSON.parse(JSON.stringify(initialState));
      return resetState;
    case "SET_LOADING":
      return {
        ...state,
        loading: action.payload,
      };
    case "SET_USUARIO":
      return {
        ...state,
        dadosusuario: action.payload,
      };
    case "SET_PERMISSOES":
      return {
        ...state,
        permissoesusuario: action.payload,
      };
    case "SET_NOTIFICACAO":
      return {
        ...state,
        notificacao: action.payload,
      };
    case "SET_ROLAGEM":
      return {
        ...state,
        rolagem: action.payload,
      };
    case "SET_PERFILSELECIONADO":
      return {
        ...state,
        perfilselecionado: action.payload,
      };
    case "SET_EMPRESASELECIONADA":
      return {
        ...state,
        empresaselecionada: action.payload,
      };
    case "SET_ENDERECOSELECIONADO":
      return {
        ...state,
        enderecoselecionado: action.payload,
      };
    case "SET_SOCIOSELECIONADO":
      return {
        ...state,
        socioselecionado: action.payload,
      };
    case "SET_SOCIODADOSSELECIONADO":
      return {
        ...state,
        sociodadosselecionado: action.payload,
      };
    case "SET_BACKPAGE":
      return {
        ...state,
        backpage: action.payload,
      };
    case "SET_NOVOSELECIONADO":
      return {
        ...state,
        novoselecionado: action.payload,
      };
    case "SET_TEMA":
      return {
        ...state,
        tema: action.payload,
      };
    case "SET_MENULATERAL":
      return {
        ...state,
        menulateral: action.payload,
      };
    case "SET_SITUACAOFISCAL":
      return {
        ...state,
        situacaofiscal: action.payload,
      };
    default:
      throw new Error();
  }
};

export const GlobalContextProvider = (props) => {
  const [state, dispatch] = useReducer(
    reducer,
    JSON.parse(JSON.stringify(initialState)),
  );

  return (
    <GlobalContext.Provider value={[state, dispatch]}>
      {props.children}
    </GlobalContext.Provider>
  );
};

export const useGlobalState = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error(
      "useGlobalState deve ser usado dentro de um GlobalContextProvider",
    );
  }
  return context;
};

export default GlobalContext;
